export default "__VITE_ASSET__xFSQ_lhv__"